<template>
  <div v-if="data" class="pa-4">
    <v-layout row wrap>
      <v-flex md9 xs7 class="label">
        <h3>
          <b>{{ data.Name }}</b>
        </h3>
      </v-flex>
      <v-flex md3 xs5 class="text-xs-right">
        <v-btn color="primary" @click="openDialogUpdateCompany(data)">
          Chỉnh sửa <v-icon right dark class="pr-0">edit</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs6 class="label">
        <v-icon>code</v-icon>
        CompanyLevelId: {{ data.CompanyLevelId }}
      </v-flex>
      <v-flex xs6 class="label">
        <v-icon>code</v-icon>
        CompanyLevelName: {{ data.CompanyLevelName }}
      </v-flex>
      <v-flex xs6 class="label">
        <v-icon>code</v-icon>
        CompanyId: {{ data.Id }}
      </v-flex>
      <v-flex xs6 class="label">
        <v-icon>directions_car</v-icon>
        Vehicle count: {{ data.Vehicles.length }}
      </v-flex>
      <v-flex xs6 class="label">
        <v-icon>group</v-icon>
        Parent: {{ data.Agent }}
      </v-flex>
      <v-flex xs6 class="label">
        <v-icon>person_pin</v-icon>
        Managed User: {{ data.Sale }}
      </v-flex>
      <v-flex xs6 class="label">
        <v-icon>person_pin</v-icon>
        User Sale: {{ data.UserSale }}
      </v-flex>
      <v-flex xs6 class="label">
        <v-icon>person_pin</v-icon>
        User CS: {{ data.UserCS }}
      </v-flex>
      <v-flex xs6 class="label">
        <v-icon>person_pin</v-icon>
        User Chargeable: {{ data.UserChargeable }}
      </v-flex>
      <v-flex xs6 class="label">
        <v-icon>perm_identity</v-icon>
        Name: {{ data.Name }}
      </v-flex>
      <v-flex xs6 class="label">
        <v-icon>contacts</v-icon>
        Contact Name: {{ data.ContactName }}
      </v-flex>
      <v-flex xs6 class="label">
        <v-icon>person</v-icon>
        Fullname: {{ data.FullName }}
      </v-flex>
      <v-flex xs6 class="label">
        <v-icon>contact_phone</v-icon>
        Contact Phone: {{ data.ContactPhone }}
      </v-flex>
      <v-flex xs6 class="label">
        <v-icon>phone</v-icon>
        Phone: {{ data.Phone }}
      </v-flex>
      <v-flex xs6 class="label">
        <v-icon>email</v-icon>
        Contact Email: {{ data.ContactEmail }}
      </v-flex>
      <v-flex xs6 class="label">
        <v-icon>location_on</v-icon>
        Address: {{ data.Address }}
      </v-flex>
      <v-flex xs6 class="label">
        <v-icon>note</v-icon>
        Remark: {{ data.Remark }}
      </v-flex>
    </v-layout>

    <dialog-update-company
      ref="dialogUpdateCompany"
      @success="handleSuccessUpdateCompany"
    />
  </div>
</template>

<script>
  import DialogUpdateCompany from '@/components/crm/DialogUpdateCompany';

  export default {
    components: {
      DialogUpdateCompany,
    },

    props: {
      data: Object,
    },

    watch: {
      data() {
        console.log('TCL: data -> data', this.data);
      },
    },

    methods: {
      openDialogUpdateCompany(data) {
        this.$refs.dialogUpdateCompany.open(data);
      },

      handleSuccessUpdateCompany(success, data) {
        if (success) {
          window.getApp.showMessage('Cập nhật thành công', 'success');
          this.$emit('updateCompany', data);
        }
      },
    },
  };
</script>

<style scoped>
  .label {
    padding-top: 8px;
  }
  .v-icon {
    padding-right: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/search/components/CompanyInfo.vue